export default __webpack_public_path__ + "static/white-b1e51830f7b232c269b070fd74574dfc.png";